import type { ReactNode } from 'react';
import { LAYOUT_GRID_TENANT_MODULES } from './tokens';

interface ModuleGridProps {
  children: ReactNode;
  /** Rótulo acessível da grade de módulos do TenantHome. */
  ariaLabel: string;
  className?: string;
}

/** Grade 2×2 no mobile — usar somente em `TenantHome`. */
export function ModuleGrid({ children, ariaLabel, className = '' }: ModuleGridProps) {
  return (
    <nav
      className={`${LAYOUT_GRID_TENANT_MODULES} ${className}`.trim()}
      aria-label={ariaLabel}
    >
      {children}
    </nav>
  );
}
